import { Box, Grid } from "@mui/material";
import moment from "moment";
import { tripData } from "store/tripSlice";
import { useSelector } from "react-redux";

const ActivitySummary = ({ summary, orderedTimeline, dataInitialized }) => {
  const trip = useSelector(tripData);
  return (
    <>
      {dataInitialized && (!orderedTimeline || orderedTimeline.length === 0) ? (
        <Grid container>
          <Grid item xs={12}>
            <Box mb={2} sx={{ display: "flex", justifyContent: "center" }}>
              <Box sx={{ color: "red", fontWeight: "bold", fontSize: "1.2rem" }}>
                No GPS Available
              </Box>
            </Box>
          </Grid>
        </Grid>
      ) : summary && (
        <Grid container>
          <Grid item xs={12} >
          <Box mb={0} sx={{ display: "flex", justifyContent: "center" }}>
              <Box sx={{ display: "flex", flexDirection: "row", flexWrap: "wrap" }}>
                <Box sx={{ display: "inline-flex" }}>
                  <Box fontWeight="fontWeightBold" display="inline" marginRight={1}>
                    Trip Number:
                  </Box>
                  {trip?.id || ''}
                </Box>
                <Box sx={{ display: "inline-flex" }}>
                  <Box fontWeight="fontWeightBold" display="inline" marginLeft={2} marginRight={1}>
                    Control Number:
                  </Box>
                  {trip?.controlNumber || ''}
                </Box>
                <Box sx={{ display: "inline-flex" }}>
                  <Box fontWeight="fontWeightBold" display="inline" marginLeft={2} marginRight={1}>
                   Pickup Time:
                  </Box>
                  {trip?.pickupDateTimeLocal ? moment(trip.pickupDateTimeLocal).format("MM/DD/YYYY HH:mm") : ''}
                </Box>
                <Box sx={{ display: "inline-flex" }}>
                  <Box fontWeight="fontWeightBold" display="inline" marginLeft={2} marginRight={1}>
                    Hub:
                  </Box>
                  {trip?.hub.name || ''}
                </Box>
                <Box sx={{ display: "inline-flex" }}>
                  <Box fontWeight="fontWeightBold" display="inline" marginLeft={2} marginRight={1}>
                    Unit #:
                  </Box>
                  {trip?.vehicle.unitNumber || ''}
                </Box>
              </Box>
              
            </Box>
          </Grid>
          <Grid item  xs={12}>
            <Box mb={2} sx={{ display: "flex", justifyContent: "center" }}>
              <Box sx={{ display: "flex", flexDirection: "row", flexWrap: "wrap" }}>
                <Box sx={{ display: "inline-flex" }}>
                  <Box fontWeight="fontWeightBold" display="inline" marginRight={1}>
                    Stops:
                  </Box>
                  {summary?.stopCount}
                </Box>
                <Box sx={{ display: "inline-flex" }}>
                  <Box fontWeight="fontWeightBold" display="inline" marginLeft={2} marginRight={1}>
                    Stop Time:
                  </Box>
                  {summary?.stopDuration_m > 60
                    ? `${(summary?.stopDuration_m / 60).toFixed(2)}h`
                    : `${summary?.stopDuration_m}m`}
                </Box>
                <Box sx={{ display: "inline-flex" }}>
                  <Box fontWeight="fontWeightBold" display="inline" marginLeft={2} marginRight={1}>
                    Driving Time:
                  </Box>
                  {summary?.drivingDuration_m > 60
                    ? `${(summary?.drivingDuration_m / 60).toFixed(2)}h`
                    : `${summary?.drivingDuration_m}m`}
                </Box>
                <Box sx={{ display: "inline-flex" }}>
                  <Box fontWeight="fontWeightBold" display="inline" marginLeft={2} marginRight={1}>
                    Distance:
                  </Box>
                  {`${summary?.drivingDistance_mi?.toFixed(2)}mi`}
                </Box>
                <Box sx={{ display: "inline-flex" }}>
                  <Box fontWeight="fontWeightBold" display="inline" marginLeft={2} marginRight={1}>
                    Driver:
                  </Box>
                  {`${trip?.driver?.name ?? "N/A"}`}
                </Box>
                <Box sx={{ display: "inline-flex" }}>
                  <Box fontWeight="fontWeightBold" display="inline" marginLeft={2} marginRight={1}>
                    Pickup:
                  </Box>
                  {`${trip?.pickupLocation?.name ?? "N/A"}`}
                </Box>
                <Box sx={{ display: "inline-flex" }}>
                  <Box fontWeight="fontWeightBold" display="inline" marginLeft={2} marginRight={1}>
                    Dropoff:
                  </Box>
                  {`${trip?.dropoffLocation?.name ?? "N/A"}`}
                </Box>
              </Box>
            </Box>
          </Grid>
        </Grid>
      )}
    </>
  );
};
export default ActivitySummary;
